import React from 'react';
import {
  addSeconds,
  differenceInSeconds,
  formatDuration,
  intervalToDuration,
} from 'date-fns';
import { useOmniverseConfig } from '../hooks/useConfig';
import { StreamingSession } from '../state/Sessions';

export interface SessionDurationProps {
  session: StreamingSession;
}

export default function SessionDuration({ session }: SessionDurationProps) {
  const config = useOmniverseConfig();
  const now = new Date();
  const duration = formatDuration(
    intervalToDuration({
      start: session.startDate,
      end: session.endDate ?? now,
    }),
    { format: ['hours', 'minutes'] }
  );

  const endTime = addSeconds(session.startDate, config.sessions.maxTtl);
  const remaining = { start: now, end: endTime };
  const timeRemaining = formatDuration(intervalToDuration(remaining), {
    format: ['hours', 'minutes'],
  });
  const diff = differenceInSeconds(remaining.end, remaining.start);

  return (
    <>
      {duration}
      {session.status !== 'STOPPED' && diff > 0 && ` (${timeRemaining} left)`}
    </>
  );
}
